import React, { useState, useCallback, useEffect } from "react";
import axios from "axios";
import Background from "../styled_components/Background";
import CenteredContainer from "../styled_components/CenteredContainer";
import { Button } from "../../../globals/components/button";
import Checkbox from "../../../globals/components/CheckboxLogin";
import useAuth from "../hooks/useAuth";
import { Loading } from "../../../globals/components/loading";
import GetSchools from "../hooks/useSchools";
import styled from "styled-components";
import Select from "react-select";
import AsyncSelect from "react-select/async";
import { withTheme } from "@material-ui/styles";
import { debug } from "util";
import { Scale } from "react-scaling";
import Logo from "../../games/assets/logo.png";
import Emile from "../../games/assets/emile_left.png";
import Scrambler from "../../games/assets/scrambler_right.png";
import background from "./../assets/background.png";
import Textfit from "react-textfit/lib/Textfit";
import { Router, navigate } from "@reach/router";

import Visibility from "@material-ui/icons/Visibility";
import Visibility_off from "@material-ui/icons/VisibilityOff";
//import { keys } from "@material-ui/core/styles/createBreakpoints";
//import { userInfo } from "os";
//import { parse } from "url";
//import setRef from "@material-ui/core/utils/setRef";

var pretypedusername = "";

var school = "";
var username = "";
var password = ""; //added because hooks keep reset upon every rerender
var SearchText = "";

var loginDots = 0;
var loginText = "Attemping login";

var realFetching = false;
var error = "";
var autologin = false;

var check;
var schoolCheck;

//remember me vars
var rememberedSchool;
var remembered;

var isSafari = false;

/* 
 

 NOTE: IF THE USERNAME BREAKS CHECK WITHIN THE CONSOLE.LOGS THAT IT'S NOT USING ANOTHER SCHOOLS VALUE RATHER THAN THE ONE YOU'RE TRYING TO USE/SELECTED
 IF ISSUE PERSISTS MORE EXPERIMENTATION/SOLUTIONS WILL BE NEEDED

please let me be done with this
*/

function Login() {
  const [pupilUsername, setPupilUsername] = useState("");
  //const [username, setUsername] = useState("");
  //const [password, setPassword] = useState("");
  //const [school, setSchool] = useState("");
  const [rememberChecked, setRememberChecked] = useState(false);
  const [rememberSchoolChecked, setRememberSchoolChecked] = useState(false);
  const [fetching, setFetching] = useState(false);
  const { dispatch } = useAuth();
  const options = GetSchools();
  const [RealOptions, setRealOptions] = useState([]);
  const [realError, setRealError] = useState("");
  //const [SearchText, setSearchText] = useState("");
  //console.log(window.location.pathname);
  const path = window.location.pathname;
  const [continued, setContinued] = useState(false);
  const [displayPassword, setDisplayPassword] = useState(false);

  //liam - debugging area
  /*
    console.log(rememberedSchool);
    console.log("pass: " + password);
    console.log("user: " + username);
   
    
    console.log("isRemembered" + remembered);
    */
  //remember me - If remember was checked then run upon next load
  useEffect(() => {
    console.log("do at start");
    if (localStorage.getItem("boolStr") === "true") {
      setRememberChecked(true);
      check = rememberChecked;
      remembered = true; //for render labels
      console.log("boolst is true");

      //get stored value
      var r_password = localStorage.getItem("rememberedPassword");

      //set up username and password
      //set school
      try {
        rememberedSchool = JSON.parse(localStorage.getItem("rememberedSchool"));
        school = String(rememberedSchool.value);
      } catch (error) {
        rememberedSchool = "";
        school = "";
      }

      SetSchoolUsername(localStorage.getItem("rememberedUsername"));
      SetPassword(r_password);
    } 

    else if (localStorage.getItem("schoolCheck") === "true"){
      console.log("school check is true");
      setRememberSchoolChecked(true);
      schoolCheck = rememberSchoolChecked;
      remembered = true;

      try {
        rememberedSchool = JSON.parse(localStorage.getItem("rememberedSchool"));
        school = String(rememberedSchool.value);
      } catch (error) {
        rememberedSchool = "";
        school = "";
      }
      SetPassword("");
      SetSchoolUsername("");
    }
    
    else if (localStorage.getItem("boolStr") != "true") {
      rememberedSchool = "";
      school = "";
      SetPassword("");
      SetSchoolUsername("");
    }
  }, []);



  useEffect(() => {
    check = rememberChecked;
    // console.log("tst: check" + check);
  }, [rememberChecked]);

  useEffect(() => {
    schoolCheck = rememberSchoolChecked;
     console.log("tst: check" + schoolCheck);
  }, [rememberSchoolChecked]);

  const attemptLogin = useCallback(
    async (e) => {
      setFetching(true);

      //if the remember me is checked then remember the inputted username and password
      if (check) {
        localStorage.setItem("rememberedUsername", username);
        localStorage.setItem("rememberedPassword", password);
        localStorage.setItem("boolStr", "true");

        localStorage.setItem("rememberedSchool", JSON.stringify(rememberedSchool));
        SetUsername(localStorage.getItem("rememberedUsername")); //removes hashtag to get original username
        remembered = true;
      } 
      else if (schoolCheck == true){
        RemoveRememberdUsername();
        localStorage.setItem("rememberedSchool", JSON.stringify(rememberedSchool));
        localStorage.setItem("schoolCheck", "true");
        localStorage.setItem("boolStr", "false");
        localStorage.setItem("rememberedPassword", "");

        remembered = false;
        
      }else if (!check) {
        console.log("hi");
        RemoveRememberdUsername();
        localStorage.setItem("rememberedPassword", "");
        localStorage.setItem("boolStr", "false");

        localStorage.setItem("rememberedSchool", "");

        remembered = false;
      }
      

      const credentials = {
        username,
        password,
        client_id: process.env.REACT_APP_OAUTH_CLIENT_ID,
        client_secret: process.env.REACT_APP_OAUTH_CLIENT_SECRET,
        grant_type: "password",
        scope: "*",
      };

      try {
        const response = await axios({
          url: `${process.env.REACT_APP_OAUTH_URL}/oauth/token`,
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          data: credentials,
        });
        dispatch({
          type: "update_token",
          payload: response.data,
        });
      } catch (e) {
        console.log("ERROR");
        setFetching(false);
        realFetching = false;
        error = e;
        setRealError(e.response.data.message);
        setrealLoginText(error.response.status + ": " + error.response.data.message);
        dispatch({ type: "remove_token" });
        // throw new Error(e);
      }
    },
    [username, password]
  );

  useEffect(() => {
    console.log(path);
    if (path.includes("auto") && !autologin) {
      //auto login with the details provided
      AutomaticLogin();
    }
  }, []);

  async function AutomaticLogin() {
    autologin = true;
    var split = path.split("/");
    console.log(path);
    console.log("hi there");
    setFetching(true);
    school = "";
    const credentials = {
      username: split[2].replace("~", "#"),
      password: split[3],
      client_id: process.env.REACT_APP_OAUTH_CLIENT_ID,
      client_secret: process.env.REACT_APP_OAUTH_CLIENT_SECRET,
      grant_type: "password",
      scope: "*",
    };
    console.log(credentials);

    try {
      const response = await axios({
        url: `${process.env.REACT_APP_OAUTH_URL}/oauth/token`,
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        data: credentials,
      });
      dispatch({
        type: "update_token",
        payload: response.data,
      });
      console.log("success!");
      navigate("/games");
    } catch (e) {
      console.log("ERROR");
      setFetching(false);
      realFetching = false;
      error = e;
      setRealError(e.response.data.message);
      setrealLoginText(error.response.status + ": " + error.response.data.message);
      dispatch({ type: "remove_token" });
      // throw new Error(e);
    }
  }
  function testcampaign() {
    /*
    var ActiveCampaign = require("activecampaign");
    var key = "02669f5d503e6cadcec72052446833c5a74d859157df836d55eee87de2570f73c73eab2a";
 
    var ac = new ActiveCampaign("https://emile.api-us1.com", key);
 
    // TEST API credentials
    ac.credentials_test().then(function(result) {
        // successful request
        if (result.success) {
            console.log("valid");
        } else {
          console.log("invalid");
        }
    }, function(result) {
      console.log("result");
    });

    var account_view = ac.api("account/view", {});
    account_view.then(function(result) {
        // successful request
        console.log(result);
    }, function(result) {
        // request error
    });

    var contact_exists = ac.api("contact_list", {});
    contact_exists.then(function(result) {
        // successful request
        console.log(result);
    }, function(result) {
      console.log(result);
        // request error
    });
 */
  }

  function SetupRealOptions() {
    var tempOptions = [];
    console.log(options);
    if (options == undefined) return;
    for (let i = 0; i < options.length && tempOptions.length < 50; i++) {
      let schoolname = options[i].school_name.toLowerCase().replace(".", "");
      schoolname = schoolname.replace("'", "");
      if (schoolname.includes(SearchText.toLowerCase()) || options[i].postcode.toLowerCase().includes(SearchText.toLowerCase())) {
        var temp = {};
        temp.value = options[i].school_id;
        temp.label = options[i].school_name;
        if (options[i].postcode != "") {
          temp.label += " (" + options[i].postcode + ")";
        }
        tempOptions.push({
          value: temp.value,
          label: temp.label,
        });
      }
    }
    //console.log(tempOptions);
    setRealOptions(tempOptions);
  }

  function SelectDrop(values) {
    console.log(values);
    //sets the schoolname to this
    school = values.value;
    rememberedSchool = values;

    if (localStorage.getItem("rememberedUsername") != "") {
      SetSchoolUsername(localStorage.getItem("rememberedUsername")); //needed to update username if only school is changed
    } else {
      SetSchoolUsername(pretypedusername);
    }
  }

  function BlankOptions() {
    console.log("Blank Options");
    if (SearchText.length < 2) {
      //console.log("blank")
      school = "";
      setRealOptions([]);
    } else {
      console.log("options = ");
      console.log(options);
      if (options != undefined) console.log("Not Blank");
      SetupRealOptions();
    }
  }

  function InputChange(value) {
    console.log(value);
    localStorage.setItem("rememberedSchool", "");
    //setSearchText(value);
    //remove full stops
    SearchText = value.replace(".", "");
    SearchText = SearchText.replace("'", "");
    //SearchText = value;
    console.log("filtering school");
    console.log(SearchText);
    if (SearchText.length > 2) {
      console.log("Not Blank");
      SetupRealOptions();
    }
  }

  function NoOptions() {
    if (SearchText.length < 2) {
      return "Enter a school name";
    } else {
      return "No school found";
    }
  }

  function SetSchoolUsername(value) {
    setPupilUsername(value);

    if (school != "") {
      console.log("why");
      username = school + "#" + value;
    } else {
      username = "#" + value;
    }

    pretypedusername = value;
  }

  var timerID;
  const [realLoginText, setrealLoginText] = useState("");
  useEffect(() => {
    //console.log("use effect 1");
    if (fetching) {
      //console.log(timerID);
      if (timerID == undefined) {
        loginText = "Attempting log in";
        setrealLoginText(loginText);
        timerID = setInterval(() => SettingLoginDots(timerID), 1000);
      }
    } else {
      clearInterval(timerID);
    }
  }, [fetching]);

  //increments the dots
  function SettingLoginDots(id) {
    //console.log(id);
    if (loginDots == 0) {
      loginText = "Attempting log in";
    }
    if (loginDots < 3) {
      loginDots += 1;
      loginText = loginText + ".";
    } else {
      loginDots = 0;
    }
    setrealLoginText(loginText);
    //console.log(realFetching);
    if (error.response != undefined) {
      //console.log(error.response);
      if (error.response.data.message != undefined) setRealError(error.response.data.message);
      else setRealError(error);
      setrealLoginText(error.response.status + ": " + error.response.data.message);
    }
    if (!realFetching) {
      clearInterval(id);
    }
  }

  function ResetError() {
    setRealError("");
    error = "";
  }

  /*
      var isSafari = navigator.vendor && navigator.vendor.indexOf('Apple') > -1 &&
    navigator.userAgent &&
    navigator.userAgent.indexOf('CriOS') == -1 &&
    navigator.userAgent.indexOf('FxiOS') == -1;
    console.log(isSafari);
    if (window.document.documentMode || isSafari) {
      isSafari = true;
    // Do IE stuff
    console.log("I am internet explorer")
    //document.getElementById("loginbox").style["display"] = "none";
    //document.getElementById("blocker").style["display"] = "";
    }
    else{
    //document.getElementById("loginbox").style["display"] = "";
    //document.getElementById("blocker").style["display"] = "none";
    }*/

  function ToggleVisibility() {
    setDisplayPassword(!displayPassword);
  }

  function ContinueLogin() {
    console.log("continue login");
    setContinued(true);
    isSafari = false;
  }

  //remember me - function to remove the hash tag from full username
  function SetUsername(value) {
    var temp = value.replace("#", " ");
    var split = temp.split(" ");
    localStorage.setItem("rememberedUsername", split[1]);
  }

  //set password with event handler
  function SetPassword(value) {
    password = value;
  }

  //if the username ever gets changed then remove the remembered username as it's no longer needed
  function RemoveRememberdUsername() {
    localStorage.setItem("rememberedUsername", "");
  }

  return (
    <Background style={{ overflow: "hidden" }}>
      <RealBackground src={background}></RealBackground>
      {!fetching && realError == "" ? (
        <Scale scaleTo={1920}>
          {isSafari && !continued ? (
            <div className="login-box" id="blocker">
              <CenteredContainer>
                <FormContent>
                  <h1>Warning!</h1>
                  <div className="tab-content">
                    <div className="tab-pane fade active in" id="teacher">
                      <h1 style={{ fontSize: "3em", textAlign: "center" }}>
                        Your web browser is not fully supported by Emile.
                        <br /> Please try the app or use Google Chrome, Mozilla Firefox or Microsoft Edge.
                        <br /> you may experience less than 100% functionality if you continue.
                      </h1>
                      <div className="form-group-replacement" style={{ margintop: "0" }}>
                        <ContinueButton
                          onClick={() => {
                            ContinueLogin();
                          }}
                        >
                          Continue to Log in
                        </ContinueButton>
                      </div>
                    </div>
                  </div>
                </FormContent>
              </CenteredContainer>
            </div>
          ) : (
            <div
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >

              {options != undefined ? (
                <div className="column">
                  <CenteredContainer>
                    <form onSubmit={attemptLogin}>
                      <img style={{ position: "relative", transform: "scale(0.8,0.8)", display: "flex" }} src={Logo}></img>
                      <FormContent>
                        <h1>Log in</h1>
                        <SchoolContainer>
                          <Select
                            className="react-select-container"
                            classNamePrefix="react-select"
                            searchable="false"
                            options={RealOptions}
                            labelField="school_name"
                            //searchBy="school_name"
                            placeholder={remembered ? rememberedSchool.label : "School"}
                            autosize={false}
                            //if details are being remmebered then set the value to the shcools label and int value else come back with nothing
                            defaultValue={remembered ? rememberedSchool.value : null}
                            onChange={(value) => SelectDrop(value)}
                            onInputChange={(inputValue) => InputChange(inputValue)}
                            onMenuOpen={() => BlankOptions()}
                            noOptionsMessage={() => NoOptions()}
                            styles={CustomStyle}
                            filterOption={false}
                            //menuIsOpen={true}
                          />
                        </SchoolContainer>

                        <input
                          type="text"
                          placeholder="Username"
                          defaultValue={remembered ? localStorage.getItem("rememberedUsername") : null} //remember me - if details were remembered then set value to remmebered username, 'less return nothing
                          onChange={(e) => {
                            RemoveRememberdUsername(); //if username is edited in anyway then remove the remembered usernameto stop username being overwritten by the remembered value
                            SetSchoolUsername(e.target.value);
                          }}
                        />

                        <input
                          id="passwordfield"
                          type={displayPassword ? "text" : "password"}
                          placeholder="Password"
                          defaultValue={remembered ? localStorage.getItem("rememberedPassword") : null} //if details were remembered then set value to the remembered password, 'less return nothing
                          onChange={(e) => SetPassword(e.target.value)}
                        />
                        {displayPassword == false ? (
                          <Visibility
                            onClick={() => {
                              ToggleVisibility();
                            }}
                            style={{ position: "relative", right: "-40%", top: "-70px", fontSize: "40px", cursor: "pointer" }}
                          />
                        ) : (
                          <Visibility_off
                            onClick={() => {
                              ToggleVisibility();
                            }}
                            style={{ position: "relative", right: "-40%", top: "-70px", fontSize: "40px", cursor: "pointer" }}
                          />
                        )}
                        <span>
                        <Checkbox
                          checked={rememberChecked}
                          defaultChecked={rememberChecked} //default to true if remember me is true
                          onChange={() => setRememberChecked(!rememberChecked)}
                          label={"Remember me"}
                        />
                        <span> </span>
                        <Checkbox
                          checked={rememberSchoolChecked}
                          defaultChecked={rememberSchoolChecked} //default to true if remember me is true
                          onChange={() => setRememberSchoolChecked(!rememberSchoolChecked)}
                          label={"Remember school"}
                        />
                        </span>
                        <a
                          href="https://games.emile-education.com/login"
                          style={{
                            textDecoration: "none",
                            fontSize: "1.5em",
                            margin: "1em",
                          }}
                        >
                          Teacher? Log in here
                        </a>
                      </FormContent>

                      <LoginButton active={true} type="submit">
                        Log in
                      </LoginButton>
                    </form>
                    <span style={{ color: "white", position: "absolute", fontSize: "2em", left: "1%", top: "93%" }}>
                      Version: {process.env.REACT_APP_VERSION_NO}
                    </span>
                    <a
                      style={{ color: "white", position: "absolute", fontSize: "2em", left: "10%", top: "93%" }}
                      href="https://www.emile-education.com/legal/privacy/"
                    >
                      Privacy Policy
                    </a>
                  </CenteredContainer>
                </div>
              ) : (
                <div className="column" style={{ fontSize: "100px" }}>
                  <CenteredContainer>
                    <FormContent style={{ width: "500px" }}>Loading...</FormContent>
                  </CenteredContainer>
                </div>
              )}
              {/* <div className="column">
                {path == "/trial" ? (
                  <TrialText>
                    <span style={{ padding: "8px" }}>
                      <br />
                      We have setup a demo student account:
                      <br />
                      <br />
                      Username: "emile"
                      <br />
                      Password: "emile"
                      <br />
                      <br />
                      To setup your own class, please use the teacher portal found here:
                      <br />
                      <br />
                      <a href="https://games.emile-education.com">https://games.emile-education.com</a>
                      <br />
                      <br />
                      With your email and address and the default password "password
                      <br />
                      <br />
                    </span>
                  </TrialText>
                ) : (
                  <TrialText style={{ width: "100%" }}>
                    <span>
                      <br />
                      Teachers to obtain free access,
                      <br /> please register your school here:
                      <br />
                      <br />
                      <a href="https://www.emile-education.com/request-a-free-trial/">https://www.emile-education.com/request-a-free-trial/</a>
                      <br />
                      <br />
                    </span>
                  </TrialText>
                )}
              </div> */}
            </div>
          )}
        </Scale>
      ) : (
        //<Loading background={false} message={"Attempting to log you in... please wait"} />
        <Scale scaleTo={1720}>
          <CenteredContainer>
            <Center>
              <LogginIn>
                <h1>{realLoginText}</h1>
                <TryAgain
                  disabled={error == ""}
                  onClick={() => {
                    ResetError();
                  }}
                  active={error != ""}
                >
                  Try again
                </TryAgain>
              </LogginIn>
            </Center>
          </CenteredContainer>
        </Scale>
      )}
      <WarningBanner>
      We do not support Safari or Internet Explorer
    </WarningBanner>
    </Background>
  );
}


const WarningBanner = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: #ff4d4d; /* Bright red/orange to grab attention */
  color: white;
  text-align: center;
  padding: 15px 0;
  font-size: 1.5em;
  font-weight: bold;
  z-index: 9999; /* Ensure it stays on top of other elements */
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.2);
  font-family: sans-serif;
`;

const TrialText = styled.div`
position: relative;
  left: 25%;
  top: 24.5%
  width: 60%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #ffffff;
  border: 2px solid #673b8b;
  border-radius: 1em;
  text-align: center
    color: #673b8b;
    font-size: 2em;
    margin: 0.25em;

  }
`;

const TrialTextHidden = styled.div`
position: relative;
left: 25%;
top: 24.5%
width: 40%;
display: flex;
flex-direction: column;
align-items: center;
background: #ffffff;
border: 2px solid #673b8b;
border-radius: 1em;

  color: #673b8b;
  font-size: 2em;
  margin: 0.25em;
  
    -moz-user-select: none; /* Firefox */
     -ms-user-select: none; /* Internet Explorer */
  -khtml-user-select: none; /* KHTML browsers (e.g. Konqueror) */
 -webkit-user-select: none; /* Chrome, Safari, and Opera */
 -webkit-touch-callout: none; /* Disable Android and iOS callouts*/
  
  
`;

const Center = styled.div`
  position: absolute;
  margin: auto;
  top: -15%;
  right: 0;
  bottom: 0;
  left: 0;
  width: 50%;
  height: 100px;
`;

const TryAgain = styled(Button)`
  text-align: center;
  width: 50%;
  height: 70px;
  margin: 5px;
  color: #fff;
  user-select: none;
  background: ${(props) => (props.active ? "#673b8b," : "#797979")};
  border: 2px solid ${(props) => (props.active ? "#e88f12" : "#6f6f6f")};

  padding: 0.5em;
  box-sizing: border-box;
  border-radius: 0.25em;
  font-size: 3em;
  cursor: ${(props) => (props.active ? "pointer" : "")};
  @media (min-width: 1025px) and (max-width: 1440px) {
    font-size: 2.5em;
  }

  @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
    margin-bottom: 0;
  }
`;

const RealBackground = styled.img`
  min-height: 100%;
  min-width: 1024px;
	
  /* Set up proportionate scaling */
  width: 100%;
  height: auto;
	
  /* Set up positioning */
  position: fixed;
  top: 0;
  left: 0;

  z-index: -1;
}

`;
const SchoolContainer = styled.div`
  width: 90%;

  .react-select__option{
    font-size: 2.5em;
  }
  .css-1uccc91-singleValue{
    font-size: 2em;
  }

  .react-select__option {
    font-size:3em;
 }

  .css-yk16xz-control {
    margin: 1em 0em;
    background: #eeeaf5;
    border: 2px solid #af9dc4;
    border-radius: 0.5em;
    font-size: 2em;
    color: #af9dc4;
  }

  .css-15rktaq-container {
    background: 0;
  }

  .css-1pahdxg-control {
    margin: 1em 0em;
    background: #eeeaf5;
    border: 2px solid #af9dc4;
    border-radius: 0.5em;
    font-size: 2em;
    color: #af9dc4;
  }

  .css-2613qy-menu {
    margin: 1em 0em;
    background: #eeeaf5;
    border: 2px solid #af9dc4;
    border-radius: 0.5em;
    font-size: 2em;
    color: #af9dc4;
  }

  .css-1laao21-a11yText{
    font-size: 2em;
  }

  .css-1ml51p6-MenuList {
    background: #eeeaf5;
    border: 2px solid #af9dc4;
    border-radius: 0.5em;
    font-size: 2em;
    color: #af9dc4;
  }
`;


const LogginIn = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #ffffff;
  border: 2px solid #673b8b;
  border-radius: 1em;
  height: 200px;
  justify-content: center;

  h1 {
    color: #673b8b;
    font-size: 3em;
    margin: 0.25em;
  }
`;

const FormContent = styled.div`
  position: relative;
  left -25%;
  width: 150%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #ffffff;
  border: 2px solid #673b8b;
  border-radius: 1em;

  h1 {
    color: #673b8b;
    font-size: 4em;
    margin: 0.25em;
  }
  

  input[type="text"],
  input[type="password"] {
    width: 85%;
    padding: 1em;
    margin: 1em 0em;
    background: #eeeaf5;
    border: 2px solid #af9dc4;
    border-radius: 0.5em;
    font-size: 2em;
    color: #af9dc4;
  }
`;

const CustomStyle = {
  container: (provided, stat) => ({
    ...provided,
    background: "#eeeaf5",
  }),
};

const SelectStyle = {
  width: "85%",
  padding: "1em",
  margin: "1em 0em",
  background: "#eeeaf5",
  border: "2px solid #af9dc4",
  borderRadius: "0.5em",
  fontSize: "2em",
  color: "#af9dc4",
};

/*
const StyledSelect = styled(Select)`
width: 85%;
background: "#eeeaf5";

    .select-container{
      background: #eeeaf5;
    }

`*/

const Container = styled.div`
      width:100%
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding-bottom:100px;
      `;

const FakeBackground = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-repeat: no-repeat;
  background-size: cover;
`;

const LoginButton = styled(Button)`
  background: ${(props) => (props.active ? "#673b8b," : "#797979")};
  border: 2px solid ${(props) => (props.active ? "#e88f12" : "#6f6f6f")};
  width: 100%;
  color: #fff;
  user-select: none;
  padding: 0.5em;
  margin: 1em 0;
  box-sizing: border-box;
  border-radius: 0.25em;
  font-size: 3em;
  cursor: pointer;
  @media (min-width: 1025px) and (max-width: 1440px) {
    font-size: 2.5em;
  }

  @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
    margin-bottom: 0;
  }
`;
const ContinueButton = styled(Button)`
  background: "#673b8b";
  border: 2px solid "#e88f12";
  width: 100%;
  color: #fff;
  user-select: none;
  padding: 0.5em;
  margin: 1em 0;
  box-sizing: border-box;
  border-radius: 0.25em;
  font-size: 3em;
  cursor: pointer;
  @media (min-width: 1025px) and (max-width: 1440px) {
    font-size: 2.5em;
  }

  @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
    margin-bottom: 0;
  }
`;

export default Login;
